'use strict';
/**
 * @ngdoc service
 * @name fetchtv.services.service inomialServiceProvider
 * undefined
 * @description Provider for inomialService
 *
 */
(function(angular) {
  angular.module('fetchtv.services')
    .provider('inomialService', [function() {
    /**
     * @ngdoc service
     * @name fetchtv.services.service inomialService
     * undefined
     * @description Provides access to customer information through inomial
     *
     */
      this.$get = [
        '$http',
        '$q',
        'proxyprefix',
        function(
          $http,
          $q,
          proxyprefix
        ) {
          var inomialPrefix = proxyprefix;// '/api';

          function onSuccess(data) {
            if (data.__meta__ && data.__meta__.error) {
              return $q.reject(data.__meta__.error);
            }
            return data;
          }

          function inomialPost(url) {
            var prefixedUrl = inomialPrefix + url;
            return $http.post(prefixedUrl)
              .then(function(result) {
                return result.data;
              })
              .then(onSuccess);
          }

          return {
            update: inomialPost.bind(undefined, '/update')
          };
        }];
    }]);
})(angular);

